import * as React from "react";
import {MouseEvent} from "react";
import {connect} from "react-redux";
import FollowListModalComponent from "../components/FollowListModalComponent";
import {followModalTabSelector, getShopsSelector, getUsersSelector} from "../../selectors";
import {changeFollow, fetchShopFollowing, fetchUserFollowers, fetchUserFollowing} from "../../middlewares";
import Meta from "../../../_data/models/Meta";
import User from "../../../_data/models/User";
import {shopsSelector, usersSelector} from "../../../_data/selectors";
import {createOrderedMapfromIDs} from "../../../_helpers/utils";

interface Props {
    showFollowing: boolean;
    profile: User;
}

const mapStateToProps = (state, ownProps: Props) => {
    const u = getUsersSelector(state);
    const s = getShopsSelector(state);
    return {
        users: {
            items: createOrderedMapfromIDs(u.ids, usersSelector(state)),
            meta: u.meta,
            loading: u.loading
        },
        shops: {
            items: createOrderedMapfromIDs(s.ids, shopsSelector(state)),
            meta: s.meta,
            loading: s.loading
        },
        showFollowing: ownProps.showFollowing,
        profile: ownProps.profile,
        followModalTab: followModalTabSelector(state)
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadUser: (id: number, e: MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            dispatch(changeFollow());
            dispatch(fetchUserFollowing(id, 1));
        },
        loadShop: (id: number, e: MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            dispatch(changeFollow());
            dispatch(fetchShopFollowing(id, 1));
        },
        loadMore: (id: number, meta: Meta, showFollowing: boolean = null, isShop: boolean = null) => {
            if (meta && meta.hasNext()) {
                if (!isShop) {
                    if (showFollowing) {
                        dispatch(fetchUserFollowing(id, meta.nextPage));
                    } else {
                        dispatch(fetchUserFollowers(id, meta.nextPage));
                    }
                }
                else {
                    dispatch(fetchShopFollowing(id, meta.nextPage));
                }
            }
        },
    }
};

const FollowListModalContainer = connect(mapStateToProps, mapDispatchToProps)(FollowListModalComponent);
export default FollowListModalContainer;


// WEBPACK FOOTER //
// ./app/client/user/modal/containers/FollowListModalContainer.tsx